
  import {Vue, Component, Prop} from 'vue-property-decorator';
  import Carousel from '@/components/Common/Carousel.vue';

  @Component({
    components: {
      Carousel
    }
  })
  export default class BaseActivity extends Vue {
    @Prop({ required: true }) readonly heading!: string;

    @Prop() readonly slideTo?: number;
  }
